import React from 'react';
import PropTypes from 'prop-types';
import { LazyImg } from '@ifeng/ui_pc_lazyLoad';
import styles from './index.css';

class ImageNav extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        url: PropTypes.string,
    };
    getNum(str) {
        let value = str.replace(/[^0-9]/gi, '');

        return value;
    }
    changeURL(url, arg_val) {
        let value = url.replace(/\d/gi, '');

        let nUrl = `${value}${arg_val}`;

        return nUrl;
    }
    render() {
        /**
         * 组件分发数据
         */

        const { content, url } = this.props;

        const loadImgUrl =
            'data:image/svg+xml;utf8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="84" height="84"><rect x="0" y="0" width="349" height="196" fill="%23f2f2f2" /></svg>';
        const cityNum = this.getNum(url);
        const name = 'city';
        const fourPicItem = content.map((item, index) => (
            <li className={styles.fourPicItem} key={index}>
                <a href={item.url.includes(name) ? this.changeURL(item.url, cityNum) : item.url}>
                    <LazyImg
                        placeholder={loadImgUrl}
                        src={item.imgURL}
                        className={styles.fourPicItemImg}
                        loadData="load success!!"
                    />
                    <h2 className={styles.fourPicItemTit}>{item.title}</h2>
                </a>
            </li>
        ));

        return (
            <section className={styles.fourNavPic}>
                <ul className={styles.fourPicBox}>{fourPicItem}</ul>
            </section>
        );
    }
}

export default ImageNav;
